module.exports = __webpack_public_path__ + "static/media/logo-cenfarte-white.507579b2.svg";